<div *ngIf="methods$ | async as methods">
  <div
    routerLink="/shipmentOptions/{{ method.id }}"
    *ngFor="let method of methods"
  >
    {{ method.name }}
  </div>
</div>
